import { render } from "./StatutoryDeductionManagement.vue?vue&type=template&id=8cd5f60e&scoped=true"
import script from "./StatutoryDeductionManagement.vue?vue&type=script&lang=js"
export * from "./StatutoryDeductionManagement.vue?vue&type=script&lang=js"

import "./StatutoryDeductionManagement.vue?vue&type=style&index=0&id=8cd5f60e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cd5f60e"]])

export default __exports__